// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__33ITS","approved":"Status_approved__1QdS9","rejected":"Status_rejected__39tH-","expired":"Status_expired__3j2JN","label":"Status_label__1TdRf"};